// Single source of truth for the backend API base URL, shared by
// RegulifyService.js, utils/wsUrl.js, and hooks/useWebSocket.js
// (previously each duplicated this literal independently).
export const DEFAULT_API_BASE = "https://apiv1.regulify.ai";

// CRA env var convention: only REACT_APP_* is exposed to the browser.
// Example: REACT_APP_API_BASE_URL="http://localhost:8077"
export function getApiBaseRoot() {
  return (
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_BASE ||
    DEFAULT_API_BASE
  );
}

export function toWsOrigin(apiBase) {
  const base = (apiBase || DEFAULT_API_BASE).trim().replace(/\/+$/, "");
  const withoutApiV1 = base.replace(/\/api\/v1$/, "");

  if (withoutApiV1.startsWith("https://")) {
    return withoutApiV1.replace("https://", "wss://");
  }
  if (withoutApiV1.startsWith("http://")) {
    return withoutApiV1.replace("http://", "ws://");
  }
  if (withoutApiV1.startsWith("wss://") || withoutApiV1.startsWith("ws://")) {
    return withoutApiV1;
  }
  return `wss://${withoutApiV1}`;
}
